let isAudioPlaying = false

/** Play notification sound effect. */
export function playNotification() {
  if (isAudioPlaying) {
    return
  }

  const audio = new Audio('https://cdn4.fireworktv.com/assets/ringtone.mp3')
  audio.play().catch(() => {
    isAudioPlaying = false
  })

  audio.addEventListener('ended', () => {
    isAudioPlaying = false
  })

  isAudioPlaying = true
}

/** Play notification sound effect for visitor without an ongoing conversation. */
export function playNewVisitorNotification() {
  if (isAudioPlaying) {
    return
  }

  const audio = new Audio(
    'https://cdn4.fireworktv.com/assets/new_visitor_ringtone.mp3',
  )
  audio.play().catch(() => {
    isAudioPlaying = false
  })

  audio.addEventListener('ended', () => {
    isAudioPlaying = false
  })

  isAudioPlaying = true
}

let ringtoneAudio: HTMLAudioElement | undefined = undefined
let handleAudioEnded: (() => void) | undefined = undefined

/**
 * Play ringtone sound effect.
 */
export function playRingtone(loop?: boolean) {
  if (isAudioPlaying) {
    return
  }

  const audio = new Audio(
    'https://cdn4.fireworktv.com/assets/call_ringtone.mp3',
  )
  audio.loop = loop === true
  ringtoneAudio = audio

  let count = loop === true ? 0 : 2

  function playAudio() {
    audio.play().catch(() => {
      isAudioPlaying = false
    })

    count--
  }

  handleAudioEnded = function () {
    audio.currentTime = 0
    if (count) {
      playAudio()
    } else {
      audio.removeEventListener('ended', handleAudioEnded!)
      handleAudioEnded = undefined
      ringtoneAudio = undefined
      isAudioPlaying = false
    }
  }

  audio.addEventListener('ended', handleAudioEnded)

  playAudio()
  isAudioPlaying = true
}

/**
 * Stop playing ringtone sound effect.
 */
export function stopRingtone() {
  if (ringtoneAudio) {
    ringtoneAudio.pause()
    ringtoneAudio.currentTime = 0
    if (handleAudioEnded) {
      ringtoneAudio.removeEventListener('ended', handleAudioEnded)
      handleAudioEnded = undefined
    }
    ringtoneAudio = undefined
    isAudioPlaying = false
  }
}
